export enum ERoleTableKey {
  Roles = 'roles',
  Title = 'title',
}

export enum ERoleRecordKey {
  Name = 'name',
  Permissions = 'permissions',
  Key = 'key',
}

export enum ERoleMenuItemKey {
  Delete = 'delete',
  Audit = 'audit',
  Duplicate = 'duplicated',
}
